module.exports = __webpack_public_path__ + "img/Elia.8015216f.png";